import React, { useEffect, useState } from "react";
import { useHooksGang } from "../../../hooks";
import {
    FragmentHeaderGang,
    FragmentTableGang,
    FragmentAddEditGang,
} from "../fragments.hrm";
import { WidgetModal } from "../../modules.widgets";
import swal from "sweetalert2";

export function PageGang() {
    const [modalTitle, setModalTitle] = useState("");
    const [modalContent, setModalContent] = useState(null);
    const [modalSize, setModalSize] = useState("lg");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [refetch, setRefetch] = useState(false);

    const { loading, gangs, getGangs, deleteGang } = useHooksGang();

    useEffect(() => {
        getGangs();
    }, [refetch]);

    const onRefetch = () => setRefetch((prev) => !prev);
    const openModal = (title, content, size = "lg") => {
        setModalTitle(title);
        setModalContent(content);
        setModalSize(size);
        setIsModalOpen(true);
    };
    const closeModal = () => setIsModalOpen(false);

    const addGang = () =>
        openModal(
            "Registrar Nuevo Grupo",
            <FragmentAddEditGang
                onRefetch={onRefetch}
                gang={{}}
                onClose={closeModal}
            />,
            "lg",
        );

    const updateGang = (data) =>
        openModal(
            "Actualizar Grupo",
            <FragmentAddEditGang
                onRefetch={onRefetch}
                gang={data}
                onClose={closeModal}
            />,
            "lg",
        );

    const onDeleteGang = async (data) => {
        const result = await swal.fire({
            title: "¿Está seguro?",
            text: "Si acepta, no podrás revertir esto!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#16a34a",
            cancelButtonColor: "#dc2626",
            confirmButtonText: "Si, Acepto!",
            cancelButtonText: "No, Cancelo!",
        });

        if (result.isConfirmed) {
            try {
                await deleteGang(data.gangID);
                onRefetch();
                swal.fire({
                    title: "Eliminado!",
                    text: `${data.gangName} ha sido eliminada`,
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false,
                });
            } catch (error) {
                console.log(error);
                swal.fire({
                    title: "Error",
                    text: "No se pudo eliminar el grupo.",
                    icon: "error",
                });
            }
        }
    };

    return (
        <>
            {/* Page header */}
            <section className="mb-6">
                <div className="max-w-full px-4">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
                            Gestión de Grupos
                        </h1>
                        <nav aria-label="breadcrumb">
                            <ol className="flex items-center gap-2 text-sm">
                                <li className="text-blue-600 dark:text-blue-400">
                                    RR.HH.
                                </li>
                                <li className="text-gray-400 dark:text-gray-500 select-none">
                                    /
                                </li>
                                <li className="text-gray-700 dark:text-gray-300 font-medium">
                                    Grupos
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </section>

            {/* Main content */}
            <section>
                <div className="max-w-full px-4">
                    <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm overflow-hidden">
                        {/* Card header */}
                        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-5 py-4 border-b border-gray-200 dark:border-gray-700">
                            <div>
                                <h2 className="text-base font-semibold text-gray-900 dark:text-white flex items-center gap-2">
                                    <i className="fas fa-users text-blue-500"></i>
                                    Lista de Grupos
                                </h2>
                                <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                    {gangs?.length ?? 0} registros encontrados
                                </p>
                            </div>
                            <FragmentHeaderGang addGang={addGang} />
                        </div>

                        {/* Card body */}
                        {loading ? (
                            <div className="flex flex-col items-center justify-center py-16 gap-3">
                                <div className="h-10 w-10 rounded-full border-4 border-blue-200 border-t-blue-600 animate-spin"></div>
                                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                                    Cargando grupos...
                                </p>
                                <p className="text-xs text-gray-400 dark:text-gray-500">
                                    Por favor espera mientras se cargan los
                                    datos
                                </p>
                            </div>
                        ) : (
                            <FragmentTableGang
                                gangs={gangs}
                                updateGang={updateGang}
                                onDeleteGang={onDeleteGang}
                            />
                        )}
                    </div>
                </div>
            </section>

            {/* Modal */}
            <WidgetModal
                isOpen={isModalOpen}
                onClose={closeModal}
                title={modalTitle}
                size={modalSize}
            >
                {modalContent}
            </WidgetModal>
        </>
    );
}
